export enum DriverTypeEnum {
  JUNK = "junk",
  BIN = "bin",
  BOTH = "both",
}

export enum BinStatusEnum {
  AVAILABLE = "available",
  ONSITE = "onsite",
  DELIVERING = "delivering",
  DUMPING = "dumping",
  DOWN = "down",
  ASSIGNED = "assigned",
}

export enum ServiceTypeEnum {
  JUNK = "junk",
  BIN = "bin",
}

export enum BinMaterialEnum {
  MIXED_WASTE = "Mixed Waste",
  MIXED_FILL = "Mixed Fill",
  SOIL = "Soil",
  BRICK = "Brick",
  CONCRETE = "Concrete",
  ASPHALT = "Asphalt",
  METAL = "Metal",
}

export enum AggregateMaterialEnum {
  CLEAR_LIMESTONE = '3/4" Clear Limestone',
  LIMESTONE_CRUSH = '3/4" Limestone Crush',
  HPB_LIMESTONE = "HPB Limestone",
  LIMESTONE_SCREENING = "Limestone Screening",
  PEA_STONE_GRAVEL = '3/8" Pea Stone Gravel',
  RIVER_STONE_GRAVEL = "River Stone Gravel",
  BRICK_SAND = "Brick Sand",
  CONCRETE_SAND = "Concrete Sand",
  STOCK_PILE_SOIL = "Stock Pile Soil",
  SCREENED_TOPSOIL = "Screened Topsoil",
  TRIPLE_MIX_SOIL = "Triple Mix Soil",
  GROW_MAX_SOIL = "Grow Max Soil",
  SHREDDED_PINE_MULCH = "Shredded Pine Mulch",
  BLACK_BEAUTY_MULCH = "Black Beauty Mulch",
  CLEAN_CONCRETE = "Clean / Concrete",
  MIX_BRICK = "Mix / Brick",
  ASPHALT = "Asphalt",
}

// Bin size is represented in yards
export enum BinSizeEnum {
  FIVE = "5",
  SIX = "6",
  TEN = "10",
  FOURTEEN = "14",
  TWENTY = "20",
  TBD = "TBD",
}

export enum JunkSizeEnum {
  ONE_THIRD = "1/3",
  TWO_THIRDS = "2/3",
  FULL = "FULL",
}

export enum JunkTypeEnum {
  NONE = "None",
  INTERIOR = "Interior",
  EXTERIOR = "Exterior",
  BOTH = "Both",
}

export enum BinTaskEnum {
  DROPOFF = "dropoff",
  PICKUP = "pickup",
  EXCHANGE = "exchange",
  DUMPANDRETURN = "dumpandreturn",
  WAITANDLOAD = "waitandload",
}

export enum SchedulePreferenceEnum {
  MORNING = "morning",
  AFTERNOON = "afternoon",
  FLEXIBLE = "flexible",
}

export enum CleanupTypeEnum {
  NONE = "none",
  FINESWEEP = "finesweep",
  FULLDETAIL = "fulldetail",
  ROUGHSWEEP = "roughsweep",
}

export enum ServiceTaskTypeEnum {
  JUNKREMOVAL = "junkremoval",
  DROPBIN = "dropbin",
  PICKUPBIN = "pickupbin",
  EXCHANGEBIN = "exchangebin",
  DUMPANDRETURNBIN = "dumpandreturnbin",
  WAITANDLOADBIN = "waitandloadbin",
}

// The CreatedBy object should be the User's collection reference and not an object with the user's details
export type CreatedByType = {
  displayName: string | null;
  email: string | null;
  uid: string; // User's collection id
};

// The Customer object should be the Customer's collection reference and not an object with the customer's details
export type CustomerType = {
  address?: string;
  email: string;
  id: string; // This is the same id as customer's id in customers collection
  name: string;
  companyName?: string | null;
  phone?: string | number;
  contacts?: ContactType[];
  customerId?: string;
  customerPhoto?: string;
};

export type ContactType = {
  email: string;
  name: string;
  phone: string | number;
  key?: number;
};

export enum TaskDriverStatusEnum {
  DRIVING_TO_SITE = "DRIVING_TO_SITE",
  TAKING_PHOTO_BEFORE_CLEANUP = "TAKING_PHOTO_BEFORE_CLEANUP",
  CLEANING_AREA = "CLEANING_AREA",
  FILLING_LOAD_SIZE = "FILLING_LOAD_SIZE",
  FILLING_LOCATION_ACCESS = "FILLING_LOCATION_ACCESS",
  TAKING_PHOTO_AFTER_CLEANUP = "TAKING_PHOTO_AFTER_CLEANUP",
  ASKING_FOR_ANOTHER_LOAD = "ASKING_FOR_ANOTHER_LOAD",
  FILLING_INTERIOR_CLEANUP_TYPE = "FILLING_INTERIOR_CLEANUP_TYPE",
  FILLING_SQFT_CLEANED = "FILLING_SQFT_CLEANED",
  FILLING_FLOORS_CLEANED = "FILLING_FLOORS_CLEANED",
  FILLING_SQFT_PER_FLOOR = "FILLING_SQFT_PER_FLOOR",
  TAKING_PHOTOS_AREAS_CLEANED = "TAKING_PHOTOS_AREAS_CLEANED",
  DRIVING_TO_DUMP = "DRIVING_TO_DUMP",
  FILLING_WEIGHT_SURCHARGE = "FILLING_WEIGHT_SURCHARGE",
  TAKING_PHOTO_DUMP_RECEIPT = "TAKING_PHOTO_DUMP_RECEIPT",
  TASK_REVIEW = "TASK_REVIEW",
  DUMP_TASKS_REVIEW = "DUMP_TASKS_REVIEW",
  ASKING_CAN_DROP_BIN = "ASKING_CAN_DROP_BIN",
  SELECTING_BIN_FOR_SERVICE = "SELECTING_BIN_FOR_SERVICE",
  FILLING_REASON_CANT_DROP_BIN = "FILLING_REASON_CANT_DROP_BIN",
  TAKING_PHOTO_DROPPED_BIN = "TAKING_PHOTO_DROPPED_BIN",
  TAKING_PHOTO_OBSTRUCTION = "TAKING_PHOTO_OBSTRUCTION",
  DRIVER_PICK_UP_BIN_ON_SITE = "DRIVER_PICK_UP_BIN_ON_SITE",
  CATEGORIZE_BIN_CONTENTS = "CATEGORIZE_BIN_CONTENTS",
  TAKING_PHOTO_BIN_CONTENTS = "TAKING_PHOTO_BIN_CONTENTS",
  WAIT_BIN_FILLED = "WAIT_BIN_FILLED",
  DRIVING_BACK_TO_SITE = "DRIVING_BACK_TO_SITE",
  JUNK_LOAD_REVIEW = "JUNK_LOAD_REVIEW",
}

export enum LocationAccessEnum {
  EASY = "EASY",
  DIFFICULT = "DIFFICULT",
}

export enum SQFTPerFloorEnum {
  FROM_0_TO_800 = "0-800",
  FROM_800_TO_1500 = "800-1500",
  MORE_THAN_1500 = "1500+",
}
